import { Skeleton } from "primereact/skeleton";
import { formatTimeToComplete } from "sj-ui-toolkit/src/utils";
import type { PassedBelt } from "sj-ui-toolkit/src/api/user";

export function PathDurationColumn({
  rowData,
  loading,
}: {
  rowData: PassedBelt;
  loading: boolean;
}) {
  if (loading) return <Skeleton />;

  return (
    <div className="flex flex-col body-sm" data-testid={`certificate-duration-${rowData.id}`}>
      <span className="text-muted-aaa">Path Duration</span>
      <span>
        <i className="pi pi-clock text-xs mr-[8px]" />
        {formatTimeToComplete(rowData.timeSpent)}
      </span>
    </div>
  );
}
